/**
 * Audit Event Emitter Service
 *
 * Fire-and-forget POST to /onboarding/api/v1/audit.
 */
import type { AuditLogRequest } from '@tms-phoenix/tms-types';
import { getApiClient } from './api.service';
import { API_ROUTES } from '@/core/config';

/**
 * Emit an audit event to the backend.
 *
 * This function intentionally swallows all errors
 * so audit instrumentation can never disrupt the application flow.
 */
export function logAuditEvent(payload: Partial<AuditLogRequest>): void {
  try {
    const api = getApiClient();
    api.post(`${API_ROUTES.ONBOARDING}/audit`, payload).catch(() => {
      // Silent: audit failures must never impact the user experience.
    });
  } catch {
    // Silent: getApiClient should not break the app.
  }
}
